<mat-expansion-panel
  class="panel-faq"
  [class.checked]="isChecked"
  (opened)="panelOpenState = true"
  (closed)="panelOpenState = false"
  hideToggle="true">
  <mat-expansion-panel-header class="panel-header">
    <mat-panel-title>
      <div class="bany-panel-header">
        <label for="button-faq-mobile" class="body-l" [class.body-l-bold]="isChecked">{{title}}</label>
      </div>
    </mat-panel-title>
    <mat-panel-description>
      <app-button
        id="button-faq-mobile"
        type="secondary"
        size="small"
        [icon]="!panelOpenState ? 'add' : 'remove'"></app-button>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <mat-accordion multi="false">
    @for (item of faqService.faqs(); track item) {
      <div>
        <app-expansion-panel
          [content]="item.answer"
          [hidden]="item.category !== faqService.activeCategory()"
          (click)="openPanel(item)"
          [title]="item.question"
          class="faq-sub-panel">
        </app-expansion-panel>
      </div>
    }
  </mat-accordion>
</mat-expansion-panel>
